import { render, staticRenderFns } from "./serviceable_pincode.vue?vue&type=template&id=ebd26440"
import script from "./serviceable_pincode.vue?vue&type=script&lang=js"
export * from "./serviceable_pincode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports